
  var usedHideScroll = 0;
  
    var scrollValue = 0;

var vBtn; 
var vForm; 

    function hideScroll(){
      scrollValue = $(document).scrollTop();
      $('html, body').addClass('no-overflow')
        //.css('top', -scrollValue).css('position', 'fixed');
      
      console.log('function hideScroll()');
      
      usedHideScroll = 1;
    }
    
       function showScroll(){
         $('html, body').removeClass('no-overflow')
           //.css('position', 'inherit').css('top', 0);
         
         $('html, body').animate({
        scrollTop: scrollValue},
        0);
         console.log('function showScroll()');
         
         usedHideScroll = 0;
      }
  
  function toggleScroll(){
    if($('html').hasClass('no-overflow')){
      showScroll();
    console.log('toggleScroll(); showing scroll');
    }
    else{
      hideScroll();
    console.log('toggleScroll(); hiding scroll');
    }
  }

  function pickWeightLimits(){
    var newVariant = vForm.find('[name="id"]').val();
    console.log('variant changed. New variant: ' + newVariant);

    if(newVariant != null){
      if(vForm.find('[name="id"] option').length > 0){
        var optionObj = vForm.find('[name="id"] option[value="'+ newVariant +'"]');
      }
      else{
        var optionObj = vForm.find('[name="id"]');
      }

      var min = optionObj.data('min-weight');
      var max = optionObj.data('max-weight');

      console.log('min: ' + min + '; max: ' + max);

      $('.weight-field').attr('min', min)
        
        if(max != ''){
          $('.weight-field').attr('max', max);
        }
      else{
        $('.weight-field').removeAttr('max');
      }
    }
  }

  function validateWeightNum(){
    console.log('weight value changed. val: ' + $('.modal__input.weight-field').val() + '; min: ' + $('.modal__input.weight-field').attr('min') + '; max: ' + $('.modal__input.weight-field').attr('max'));
      if(Number($('.modal__input.weight-field').val()) < Number($('.modal__input.weight-field').attr('min')) || Number($('.modal__input.weight-field').val()) > Number($('.modal__input.weight-field').attr('max'))){
        $('.modal__input.weight-field').parents('.form-block').find('.error-text').slideDown(300);
        console.log('Should slide down');
      }
      else{
        $('.modal__input.weight-field').parents('.form-block').find('.error-text').slideUp(300); 
        console.log('Should slide up');
      }
  }

function validateAge(){
  var parent = $('.years-field').parents('.age-holder');
  var years = Number($('.years-field').val());
  var months = Number($('.months-field').val());
  var minMonths = Number($('.months-field').data('min'));
console.log('years: ' + years + '; months: ' + months);
  if(years == 0){

    if(months < minMonths){
      parent.find('.error-text').slideDown(300);
      $('.verificationModalSubmit').addClass('disabled');
    }
    else{
      parent.find('.error-text').slideUp(300);
      $('.verificationModalSubmit').removeClass('disabled');
    }
  }
    else{
      parent.find('.error-text').slideUp(300);
      $('.verificationModalSubmit').removeClass('disabled');
    }
}

function pickPetType(){
  var newVariant = vForm.find('[name="id"]').val();
    console.log('pickPetType variant changed. New variant: ' + newVariant);

    if(newVariant != null){
      if(vForm.find('[name="id"] option').length > 0){
        var optionObj = vForm.find('[name="id"] option[value="'+ newVariant +'"]');
      }
      else{
        var optionObj = vForm.find('[name="id"]');
      }
      var newPetTypes = optionObj.data('pet-type');

      $('#pet-verification-popup .form-option-holder.pet-type-field input[type="radio"]').each(function(){

        var tag = $(this).data('type-tag');

        if(newPetTypes.indexOf(tag) > -1){
          $(this).attr('disabled', false);
        }
        else{
          $(this).attr('disabled', true);
        }
        
      })
    }
  
}

function checkCartPopup(){

  if($('.cart-item-container[data-has-it="1"]').length > 0){
    console.log('should show popup');
    $('.cart-finish').addClass('showPopup');
  }
  else{
    $('.cart-finish').removeClass('showPopup');
  }
  
}

function cartPopupFunctions(){

  checkCartPopup();

  $(document).on("DOMSubtreeModified", 'form[action="/cart"]:not(.customForm)', function(){ 
    console.log('cart changed. Checking popup');
   checkCartPopup();
  })

  $(document).on('click','.cart-submit-popup',function(){
    
    console.log('showing popup now');

     $('html').addClass('modal-open');
      hideScroll();

    var prescriptionHtml = '';
    var prescriptionIds = '';
    
    $('.cart-items .cart-item-container[data-has-it="1"]').each(function(){

      if(prescriptionIds.indexOf($(this).data('id')) == -1){
        prescriptionIds+= $(this).data('id');
      prescriptionHtml = prescriptionHtml + $(this).prop('outerHTML');
    }
    });
console.log(prescriptionHtml);
    $('.prescription-items-holder').html('');
    $('.prescription-items-holder').html(prescriptionHtml);

    
    $('#prescription-popup').fadeIn(300);
    
  })
}

$(document).ready(function(){

  cartPopupFunctions();

  if($('#pet-verification-popup').length > 0){
    
    $(document).on('click', '.verificationOpen', function(e){
      e.preventDefault();
      
      vBtn = $(this);
      vForm = vBtn.parents('form');

      console.log('form class:', vForm.attr('class'));
      
      pickWeightLimits();
      if($('.modal__input.weight-field').val().length > 0){
      validateWeightNum();
      }
      pickPetType();
      
      $('html').addClass('modal-open');
      hideScroll();
      console.log('should open popup');
    $('#pet-verification-popup').fadeIn(300);

      var variantId = $(this).parents('form').find('[name="id"]').val();
      
$('.verification-variant-id').val(variantId);
  })

 $('.modal__close').click(function(){
   showScroll();
 $(this).parents('.modal__overlay').fadeOut(300);
      $('html').removeClass('modal-open');
    })

    $(".modal__overlay").click(function(e){
      
     if(e.target !== e.currentTarget) return;
      showScroll();
      $(this).fadeOut(300);
      $('html').removeClass('modal-open');
});
    
//pickWeightLimits();
    
    $('select[name="id"]').change(function(){
      
      vBtn = $(this);
      vForm = vBtn.parents('form');
      
      pickWeightLimits();
      if($('.modal__input.weight-field').val().length > 0){
      validateWeightNum();
      }
      pickPetType();
    })

    $('.modal__input.weight-field').change(function(){
      validateWeightNum();
    })
  }

$(document).on('input','.age-field', function(){
    validateAge();
  })

  theme.initAddToCartButton = function ($button) {
  $button.on('click', function (evt) {
    evt.preventDefault();
    var $btn = $(this);
    var $form = $btn.closest('form');
    // Disable button
    $btn.attr('disabled', 'disabled').data('previous-value', $btn.html()).html(theme.strings.addingToCart);
    // Add to cart
    $.post(theme.routes.cart_add_url + '.js', $form.serialize(), function (itemData) {
      // Enable button
      $btn.removeAttr('disabled').html(theme.strings.addedToCart);
      // Fetch updated cart data
      $.getJSON(theme.routes.cart_url + '.js', function (cartData) {
        // Update cart item count in the header
        var $cartItemCount = $('.header-cart__count');
        $cartItemCount.text(cartData.item_count);

        // Show the added notice
        var $addedNotice = $('<div class="added-notice global-border-radius added-notice--pre-reveal">' +
          '<div class="added-notice__header">' +
          '<span class="added-notice__title">' + theme.strings.addedToCartPopupTitle + '</span>' +
          '<a class="added-notice__close feather-icon" href="#" aria-label="' + theme.strings.close + '">' + theme.icons.close + '</a>' +
          '</div>' +
          '<div class="cart-summary global-border-radius">' +
          '<div class="cart-summary__product">' +
          'Product added to cart</div>' +
          '</div>' +
          '<div class="cart-summary__footer">' +
          '<div class="cart-summary__total-quantity-row">' +
          '<span>' + theme.strings.addedToCartPopupItems + '</span>' +
          '<span>' + cartData.item_count + '</span>' +
          '</div>' +
          '<div class="cart-summary__total-price-row large-text">' +
          '<span>' + theme.strings.addedToCartPopupSubtotal + '</span>' +
          '<span class="theme-money">' + theme.Shopify.formatMoney(cartData.total_price, theme.moneyFormatWithCodeForCartPreference) + '</span>' +
          '</div>' +
          '<a href="' + theme.routes.cart_url + '" class="btn btn--primary btn--small btn--fullwidth cart-summary__button">' + theme.strings.addedToCartPopupGoToCart + '</a>' +
          '</div>' +
          '</div>');

        // Append the added notice to the body
        $addedNotice.appendTo('body');
        // Show the added notice
        $addedNotice.removeClass('added-notice--pre-reveal');

        // Handle close button click
        $addedNotice.find('.added-notice__close').on('click', function (evt) {
          evt.preventDefault();
          $addedNotice.remove(); // Remove the added notice from the DOM
        });

        // Hide the added notice after a certain time
        setTimeout(function () {
          $addedNotice.find('.added-notice__close').trigger('click');
        }, 10000);
      });
    });
  });
};

$('.verificationModalSubmit').click(function(){
  $('.required-holder').each(function(){

    console.log('found required');

    var parent = $(this);

    var inputs = parent.find('input:not([type="hidden"])');
    if(inputs.length == 1){
if(!inputs.val()){
  console.log('input invalid');
parent.addClass('error');
}
      else{
parent.removeClass('error');
  console.log('input valid');
}
    }
    else{
      console.log(inputs.first().attr('type'), inputs.first().attr('name'));
      if(inputs.first().attr('type') == 'checkbox'){
        console.log('checkboxes: ', parent.find('input[required]').length, parent.find('input:checked').length);
        if(parent.find('input[required]').length == parent.find('input:checked').length){
          parent.removeClass('error');
  console.log('input is valid');
        }
        else{
          parent.addClass('error');
  console.log('input is invalid');
        }
      }
      else if(inputs.first().attr('type') == 'radio'){
        console.log('radioboxes: ',parent.find('input[required]:checked').length);
        if(parent.find('input[required]:checked').length == 1){
           parent.removeClass('error');
  console.log('input valid');
        }
        else{
          parent.addClass('error');
  console.log('input invalid');
        }
}
    }
  })
})
  
  $(document).on('submit', '.pet-verification-form', function(e){
    e.preventDefault();
    
  //  if($('.pet-type-field input:checked').length == 1){
    
  //  console.log('form is stopped from submitting');

    $('.modal__form-elements [required]').each(function(){
      
    })

    
     var form = $(this);
    var actionUrl = form.attr('action');
    
    $.ajax({
        type: "POST",
        url: actionUrl,
        data: form.serialize(), // serializes the form's elements.
        success: function(data)
        {
          window.location.href = '/cart';
        }
    });
   // }
  })

$(document).on('change','.pet-type-field input',function(){
  $('.pet-type-backup').val($(this).val());
})

      $(document).on('click', 'a[href="#freeShippingPopup"]', function(e){
      e.preventDefault();
      
      $('html').addClass('modal-open');
      hideScroll();
      console.log('should open popup');
    $('#freeShippingPopup').fadeIn(300);

  })
  
})

$(document).on('click','.cc-filter__toggle',function(e){
  e.preventDefault();
})

$(document).ready(function() {
  var title = $('title');
  var description = $('meta[name=description]');
  var current_page = $('meta[data-current-page]').attr('data-current-page');
  if(current_page && current_page > 1) {
    title.html(title.html() + ' - Page ' + current_page);
    description.attr('content', description.attr('content') + ' - Page ' + current_page);
  }
});
